import { AxiosInstance } from 'axios';
import { IExistUnprocessedChildOrdersRepository } from '@/model/repository/facility-store/IExistUnprocessedChildOrdersRepository';

export default (Repository: AxiosInstance) => (): IExistUnprocessedChildOrdersRepository => ({
  getExistUnprocessedChildOrders({ facilityId }) {
    return Repository.get(`/facility-store-api/admin/facility/${facilityId}/existUnprocessedChildOrders`);
  },
});
